"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsiblePanel = void 0;
var react_1 = __importDefault(require("react"));
var index_1 = require("./icons/index");
var CollapsiblePanel = function (_a) {
    var label = _a.label, isOpen = _a.isOpen, content = _a.content, onChange = _a.onChange, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (react_1.default.createElement("div", { className: "collapsible-panel ".concat(className).trim() },
        react_1.default.createElement("button", { type: "button", className: "collapsible-panel__toggle", onClick: function () { return onChange(!isOpen); }, "aria-expanded": isOpen },
            react_1.default.createElement("span", { className: "collapsible-panel__label" }, label),
            react_1.default.createElement("span", { className: "collapsible-panel__chevron".concat(isOpen ? ' collapsible-panel__chevron--open' : '') }, (0, index_1.makeIcon)('chevron-down', '24px'))),
        react_1.default.createElement("div", { className: "collapsible-panel__body".concat(isOpen ? ' collapsible-panel__body--open' : ''), "aria-hidden": !isOpen },
            react_1.default.createElement("div", { className: "collapsible-panel__inner" }, content))));
};
exports.CollapsiblePanel = CollapsiblePanel;
